import PostMessageEmitter from '/auto-message/src/common/js/lib/PostMessageEmitter';
import store from '/auto-message/src/redux/store';
import Constant from '/auto-message/src/lib/Constant'

function getEmitter()
{
    return new PostMessageEmitter(
        window.parent,
        Constant.parentDomain
    );
}

export default getEmitter;



// WEBPACK FOOTER //
// ./postmessage/emitter.js